import {Options} from "flatpickr/dist/types/options";

const CustomFlatPickerForTime: Partial<Options> = {
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true
}

export {CustomFlatPickerForTime}